import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ddw-admin-page-card',
  templateUrl: './admin-page-card.component.html',
  styleUrls: ['./admin-page-card.component.css']
})
export class AdminPageCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
